export const scrollToObject = (eleId:any, offset:number) => {
    let ele:any = document.getElementById(eleId);
    if (ele) {
      if (offset!==null && offset!==undefined) {
        ele.style.scrollMarginTop = `${offset}px`;
      }
      ele.scrollIntoView({ behavior: 'smooth', block: 'start' });    
    }
  };
  

export const scrollToCenterObject = (eleId:any) => {
  let ele:any = document.getElementById(eleId);
  if (ele) {
    ele.scrollIntoView({ behavior: "smooth", block: "center" });
  }
};